import {
    defaultMarketResearchState,
    MarketResearchSearchCriteria,
    MarketResearchState,
    RelodeApiError,
} from "@relode/core";
import { JobManagerContact } from "@relode/core/domain";

interface MarketResearchOverviewData {
    overview: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: {
            isSharedFromAdmin: boolean;
            canUpsellMarketResearch: boolean;
            canAccessJobMarketResearch: boolean;
            jobManager: JobManagerContact;
        };
    };
}

export type ClientPublicMarketResearchSearchResults = MarketResearchState &
    MarketResearchOverviewData;

export type ClientPublicMarketResearchState = {
    searchMode: "configure" | "search";

    searchCriteria: MarketResearchSearchCriteria;

    searchResults: ClientPublicMarketResearchSearchResults;
};

export const defaultClientPublicMarketResearchState: ClientPublicMarketResearchState =
    {
        searchMode: "configure",

        searchCriteria: undefined,
        searchResults: {
            ...defaultMarketResearchState,
            overview: {
                isBusy: false,
                error: undefined,
                data: {
                    isSharedFromAdmin: false,
                    canUpsellMarketResearch: true,
                    canAccessJobMarketResearch: false,
                    jobManager: undefined,
                },
            },
        },
    };
